import { render, staticRenderFns } from "./DistrictInfoDetails.vue?vue&type=template&id=5a310de0&scoped=true&"
import script from "./DistrictInfoDetails.vue?vue&type=script&lang=js&"
export * from "./DistrictInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./DistrictInfoDetails.vue?vue&type=style&index=0&id=5a310de0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a310de0",
  null
  
)

export default component.exports